import { Switch } from 'react-router-dom';

import drawRoutes from './router/utils/drawRoutes';
import { getRoutes } from './router/routes';

const App = () => {
  return <Switch>{drawRoutes(getRoutes())}</Switch>;
};

export default App;
